import React from "react";
import CircleIcon from "@mui/icons-material/Circle";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
function DeviceCard({ codeAcm, addresAcm, statueAcm, mappath }) {
  const { t } = useTranslation();

  return (
    <Link to={mappath} target="_blank" style={{ textDecoration: "none" }}>
      <Box
        className={`flex border-2 ${
          statueAcm ? "border-teal" : "border-red"
        } rounded-md p-2 gap-3 my-4 hover:bg-[#f4f4f5]`}
      >
        {/* Image */}
        <Box className="mr-2 flex-shrink-0">
          <img
            src="/images/Thumbnail.webp"
            width={81}
            className="rounded-lg shadow-sm"
            alt="location thumbnail"
          />
        </Box>

        {/* Content */}
        <Box className="flex flex-col justify-between flex-grow overflow-hidden">
          {/* Top Row: Device ID and Status */}
          <Box className="flex  items-center justify-between">
            <Typography className="text-sm" noWrap>
              {t("Device.ID")} {codeAcm}
            </Typography>
            <Box className="flex items-center gap-1">
              <Typography
                variant="subtitle2"
                color={statueAcm ? "success" : "error"}
              >
                {statueAcm ? t("Device.Active") : t("Device.Inactive")}
              </Typography>
              <CircleIcon
                fontSize="small"
                color={statueAcm ? "success" : "error"}
              />
            </Box>
          </Box>

          {/* Address */}
          <Box mt={1}>
            <Typography
              variant="body2"
              className="break-words whitespace-pre-wrap"
            >
              {t("Device.Address")} {addresAcm}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Link>
  );
}

export default DeviceCard;
